import React, { memo } from 'react'
import styled from 'styled-components'
import { pluralizeToString } from 'lib/pluralize'
import Group from 'components/utils/Group'
import Image from 'components/Common/Image/Image'
import BodyText from 'components/Luxkit/Typography/BodyText'
import NumberRating from 'components/Common/NumberRating/NumberRating'
import { getTourOperatorCountry } from './utils'

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30%;
`

interface Props {
  tour: Tours.V2Offer;
}

function TourV2OperatorReview(props: Props) {
  const { tour } = props

  // TODO: Remove this when those infos comes from svc-tour
  const tourOperatorCountry = getTourOperatorCountry(tour.id)

  const operatorName = tour.brand.name
  const operatorLogo = tour.brand.logoImage
  const tourOperatorLabel = tourOperatorCountry ?
    `This score reflects the average rating given by customers who completed tours with the ${tourOperatorCountry} tour operator partner.` :
    `This score reflects the average rating given by customers across all tours operated by ${operatorName}.`

  return (
    <Group direction="vertical" tabletDirection="horizontal" horizontalAlign="center" verticalAlign="center" gap={24}>
      {operatorLogo && (
        <ImageContainer>
          <Image
            id={operatorLogo.id}
            dpr={2}
            quality="eco"
            width={150}
            alt={operatorLogo.title}
            aria-hidden="true"
          />
        </ImageContainer>
      )}
      <Group direction="vertical" gap={20}>
        <NumberRating
          variant="xl"
          rating={tour.reviewsRating}
          ratingSubtitle="Tour Operator rating"
        />
        <BodyText variant="large" weight="bold">{pluralizeToString('review', tour.reviewsTotal)}</BodyText>
        <BodyText variant="medium" colour="neutral-two">{tourOperatorLabel}</BodyText>
      </Group>
    </Group>
  )
}

export default memo(TourV2OperatorReview)
